import { Fragment } from "react";
import Link from "next/link";
import { Transition, Popover, Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";

//internal import
import { pages } from "@utils/data";
import Category from "@component/category/Category";

const NavbarPromo = () => {
  return <>
    <div className="hidden lg:block xl:block bg-gray-50 border-b border-gray-200 shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-3 sm:px-10 h-12 flex justify-between items-center">
        <div className="inline-flex">
          <Popover className="relative">
            <div className="max-w-7xl mx-auto">
              <div className="flex justify-between items-center md:justify-start md:space-x-10">
                <div className="md:flex space-x-10 items-center">
                  <Menu as="nav">
                    <Menu.Button className="group inline-flex items-center py-2 text-gray-700 hover:text-red-500 focus:outline-none transition-colors duration-300">
                      <span className="font-serif text-sm font-medium">
                        Categories
                      </span>
                      <ChevronDownIcon
                        className="ml-1 h-3 w-3 group-hover:text-red-500 transition-transform duration-300"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Menu.Items className="absolute z-10 -ml-1 mt-1 transform w-screen max-w-xs c-h-65vh bg-white rounded-xl shadow-xl border border-gray-100">
                        <Menu.Item>
                          <div className="overflow-y-scroll flex-grow scrollbar-hide w-full h-full">
                            <Category />
                          </div>
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
                <Popover.Group
                  as="nav"
                  className="md:flex space-x-4 items-center"
                >
                  <Link
                    href="/about-us"
                    className="font-serif mx-4 py-2 text-sm font-medium text-gray-700 hover:text-red-500 transition-colors duration-300">
                    About Us
                  </Link>

                  <Link
                    href="/contact-us"
                    className="font-serif mx-4 py-2 text-sm font-medium text-gray-700 hover:text-red-500 transition-colors duration-300">
                    Contact Us
                  </Link>

                  <Popover className="relative font-serif">
                    <Popover.Button className="group inline-flex items-center py-2 text-sm font-medium text-gray-700 hover:text-red-500 focus:outline-none transition-colors duration-300">
                      <span>Pages</span>
                      <ChevronDownIcon
                        className="ml-1 h-3 w-3 group-hover:text-red-500 transition-transform duration-300"
                        aria-hidden="true"
                      />
                    </Popover.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute z-10 -ml-1 mt-1 transform w-screen max-w-xs bg-white rounded-xl shadow-xl border border-gray-100">
                        <div className="overflow-y-scroll flex-grow scrollbar-hide w-full h-full p-2">
                          <div className="relative grid gap-2 px-4 py-4">
                            {pages.map((item) => (
                              <span
                                key={item.title}
                                className="p-2 flex font-serif items-center rounded-md hover:bg-gray-50 w-full hover:text-red-500 transition-colors duration-300"
                              >
                                <item.icon
                                  className="flex-shrink-0 h-4 w-4"
                                  aria-hidden="true"
                                />
                                <Link
                                  href={item.href}
                                  className="inline-flex items-center justify-between ml-2 text-sm font-medium w-full hover:text-red-500">
                                  {item.title}
                                </Link>
                              </span>
                            ))}
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </Popover>

                  <Link
                    href="/offer"
                    className="relative inline-flex items-center h-6 bg-gradient-to-r from-red-500 to-red-600 font-serif ml-4 py-0 px-3 rounded-full text-sm font-medium text-white hover:shadow-md transition-all duration-300 transform hover:scale-105">
                    Offers
                    <div className="absolute flex w-2.5 h-2.5 left-auto -right-1 -top-1">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-orange-40"></span>
                    </div>
                  </Link>
                </Popover.Group>
              </div>
            </div>
          </Popover>
        </div>

        <div className="flex">
          <Link
            href="/privacy-policy"
            className="font-serif mx-4 py-2 text-sm font-medium text-gray-700 hover:text-red-500 transition-colors duration-300">
            Privacy Policy
          </Link>

          <Link
            href="/terms-and-conditions"
            className="font-serif mx-4 py-2 text-sm font-medium text-gray-700 hover:text-red-500 transition-colors duration-300">
            Terms & Conditions
          </Link>
        </div>
      </div>
    </div>
  </>;
};

export default NavbarPromo;
